import { UI } from '../UI';
import { App } from '../App';
import { User } from '../User';
import { appConfig as $config } from '../../app.config';
import { Common } from '../Common';

export const ApprovalPDF = (function () {
  let $templates = [];

  const loadTemplates = () => {
    return new Promise((resolve) => {
      $.when(App.ajaxData(
        `approval/pdf/templates/${User.accountID()}`,
        {},
        'GET',
        'application/json',
        true,
      )).done((templates) => {
        resolve(templates);
        $templates = templates;
      });
    });
  };

  const dialog = (artworkIds) => {
    const template = require('./tmpl/dialog.hbs');
    bootbox
      .dialog({
        size: 'medium',
        title: $lang.btn.download,
        message: template({
          templates: $templates,
          $lang: $lang,
        }),
        buttons: {
          download: {
            label: $lang.btn.approve,
            className: 'btn btn-success',
            callback: function () {
              return submit(artworkIds);
            }
          },
          cancel: {
            label: $lang.btn.cancel,
            className: 'btn btn-link'
          }
        }
      })
      .init(() => {
        $('#ApprovalPDFModalForm select[name="template"]').select2();
      });
  };

  const submit = (artworkIds) => {
    const form = $('#ApprovalPDFModalForm');
    const formData = form.length ? form.serializeObject() : null;

    const body = {
      artworkIds,
      templateName: formData.template,
    };

    UI.blockPage();
    $.ajax({
      url: `${$config.apiURL}approval/pdf/artworks/generate`,
      method: 'POST',
      data: JSON.stringify(body),
      contentType: 'application/json',
      xhrFields: {
        responseType: 'blob'
      },
      headers: App.ajaxHeaders(),
      success: function(data) {
        const blob = new Blob([data], { type: 'application/zip' });
        const url = URL.createObjectURL(blob);

        Common.saveFile(url, 'Approval PDF.zip');
        URL.revokeObjectURL(url);
      },
      error: () => UI.errorMessage('Unknown error')
    }).always(() => UI.unblockPage());
  };

  return {
    loadTemplates,
    dialog,
  };
})();
